import React from 'react'
import Card from '../components/Card'
import { Link } from 'react-router-dom'

export default function Pricing() {
  return (
    // <div className="container">
    //   <section className="card">
    //     <h2 className="h2">Pricing & plans</h2>
    //     <p className="kv">Simple pricing to get you started. Platform fee is included when you request a bookkeeper.</p>

    //     <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
    //       <Card className="center">
    //         <div style={{fontWeight:700}}>One-time cleanup</div>
    //         <div style={{fontWeight:700, fontSize:28, marginTop:8}}>$199</div>
    //         <div className="kv" style={{marginTop:8}}>One-time review & cleanup of accounts</div>
    //         <div style={{marginTop:12}}><Link to="/signup" className="btn primary">Choose</Link></div>
    //       </Card>

    //       <Card className="center" style={{border:'3px solid var(--accent-100)'}}>
    //         <div style={{fontWeight:700}}>Monthly bookkeeping</div>
    //         <div style={{fontWeight:700, fontSize:28, marginTop:8}}>$299 / mo</div>
    //         <div className="kv" style={{marginTop:8}}>Monthly reconciliations, reports & support</div>
    //         <div style={{marginTop:12}}><Link to="/signup" className="btn primary">Choose</Link></div>
    //       </Card>

    //       <Card className="center">
    //         <div style={{fontWeight:700}}>Tax filing support</div>
    //         <div style={{fontWeight:700, fontSize:28, marginTop:8}}>From $399</div>
    //         <div className="kv" style={{marginTop:8}}>Tax prep, filings and advisory</div>
    //         <div style={{marginTop:12}}><Link to="/signup" className="btn primary">Choose</Link></div>
    //       </Card>
    //     </div>
    //   </section>
    // </div>
    <div className="container">
      <section className="card">
        <h2 className="h2">Pricing</h2>

        <div style={{display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>Project Initiation and Planning</div><div className="kv">Sign up and tell us a bit about yourself or your business.</div></Card>
          <Card><div style={{fontWeight:700}}>Project Execution</div><div className="kv"><Link to="/directory">Product Offerings</Link></div></Card>
          <Card><div style={{fontWeight:700}}>Project Monitoring and Control</div><div className="kv">Use in-app messaging to discuss details and ask questions.</div></Card>
          <Card><div style={{fontWeight:700}}>Project Wrapup</div><div className="kv">Use in-app messaging to discuss details and ask questions.</div></Card>

          {/* <Card><div style={{fontWeight:700}}>3. Chat and collaborate with our team members</div><div className="kv">Securely upload receipts, statements and invoices.</div></Card> */}
        </div>

        {/* <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>4. Recurring or non-recurring</div><div className="kv">Support services that is expected to recur over a period of time or one-time support services. </div></Card>
          <Card><div style={{fontWeight:700}}>5. Review and Approve Project Delivery</div><div className="kv">Approve the delivered work </div></Card>
          <Card><div style={{fontWeight:700}}>6. Approve and Pay</div><div className="kv">Discuss and agree on payment terms and support service fee.</div></Card>
        </div> */}
      </section>
    </div>
  )
}
